import { render, staticRenderFns } from "./ThreadEnvelope.vue?vue&type=template&id=75f0020a&scoped=true"
import script from "./ThreadEnvelope.vue?vue&type=script&lang=js"
export * from "./ThreadEnvelope.vue?vue&type=script&lang=js"
import style0 from "./ThreadEnvelope.vue?vue&type=style&index=0&id=75f0020a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f0020a",
  null
  
)

export default component.exports